import InlineSvg from "../components/utils/inline-svg";

const _baseUrl = process.env.REACT_APP_CLOUDFRONT_BASE + "/assets/";

const assetIcons = {
  twitter: `${_baseUrl}pngs/twitter.png`,
  google: `${_baseUrl}pngs/google.png`,
  facebook: `${_baseUrl}pngs/facebook.png`,
  tiktok: `${_baseUrl}pngs/tiktok.png`,
  discord: `${_baseUrl}pngs/discord.png`,
  settings: `${_baseUrl}pngs/navbar-settings.png`,
  logout: `${_baseUrl}pngs/navbar-logout.png`,
  digitalWallet: `${_baseUrl}svgs/digital-wallet.svg`,
  homeSidebar: `${_baseUrl}svgs/home-sidebar.svg`,
  communitySidebar: `${_baseUrl}svgs/community-sidebar.svg`,
  streamSidebar: `${_baseUrl}svgs/signal-stream.svg`,
  seeMoreIcon: `${_baseUrl}svgs/see-more-icon.svg`,
  addIcon: `${_baseUrl}svgs/add.svg`,
  currencyIcon: `${_baseUrl}svgs/usdc-logo-small.svg`,
  headphones: `${_baseUrl}svgs/headphones.svg`,
  chatOnline: `${_baseUrl}svgs/chat-online.svg`,
  sendIcon: `${_baseUrl}svgs/send-icon.svg`,
  cancelIcon: `${_baseUrl}svgs/cancel.svg`,
  upArrow: `${_baseUrl}svgs/up-arrow.svg`,
  visa: `${_baseUrl}svgs/visa.svg`,
  downArrow: `${_baseUrl}svgs/down-arrow.svg`,
  visaWithdraw: `${_baseUrl}svgs/visa-withdraw.svg`,
  leftArrow: `${_baseUrl}svgs/left-arrow.svg`,
  dice: `${_baseUrl}svgs/dice.svg`,
  cctvIcon: `${_baseUrl}svgs/cctv-icon.svg`,
  walletIcon: `${_baseUrl}svgs/wallet-icon.svg`,
  profileIcon: `${_baseUrl}svgs/profile-icon.svg`,
  shieldIcon: `${_baseUrl}svgs/shield-icon.svg`,
  congrats: `${_baseUrl}svgs/congrats.svg`,
  notFoundIcon: `${_baseUrl}svgs/404.svg`,
  serverError: `${_baseUrl}svgs/5xx.svg`,
};

const assetImages = {
  heroImage: `${_baseUrl}png/hero-login-compressed.jpg`,
  heroFullImage: `${_baseUrl}pngs/athlete-full.png`,
  heroBgImage: `${_baseUrl}pngs/athlete-bg-mask-group.png`,
  logo: `/logo.png`,
  vector: `${_baseUrl}pngs/vector.png`,
  homePageBg: `${_baseUrl}pngs/home-banner-1.jpg`,
  homePageNewBg1: `${_baseUrl}png/home-banner-1.jpg`,
  homePageNewBg2: `${_baseUrl}png/home-banner-2.jpg`,
  homePageNewBg3: `${_baseUrl}png/home-banner-3.jpg`,

  metamask: `${_baseUrl}png/metamask-logo.png`,

  coinbase: `${_baseUrl}png/coinbase-logo.png`,

  trustWallet: `${_baseUrl}png/trustwallet-logo.png`,
  homePageAthlete: `${_baseUrl}pngs/home-page-athlete.png`,
  homePageBgNew: "/placeholder.jpg",
  findMatchBg: `${_baseUrl}pngs/find-match.png`,
  findMatchActiveBg: `${_baseUrl}pngs/find-match-active.png`,
  microscope: `${_baseUrl}pngs/microscope.png`,
  logoutImage: `${_baseUrl}pngs/logout.png`,
  warning: `${_baseUrl}pngs/warning.png`,
  walletBg: `${_baseUrl}pngs/wallet-bg.png`,
  walletLogo: `${_baseUrl}pngs/wallet-logo.png`,
  navbarProfileAvatar: `${_baseUrl}pngs/navbar-profile-avatar.png`,
  mobileHeroSectionBg: `${_baseUrl}pngs/mobile-home-carousal-bg.png`,
  community: `${_baseUrl}pngs/blogs-banner-wo-text.png`,
  mobCommunity: `${_baseUrl}pngs/blogs-banner-wo-text.png`,
};

const assetVideos = {
  heroVideo: "<URL>",
  // Add more as needed
};
const CurrencyIcon = () => (
  <InlineSvg sx={{ mr: 1 }} url={assetIcons.currencyIcon} />
);
export { assetIcons, assetImages, assetVideos, CurrencyIcon };
